import React from 'react';

function Footer({ scrollToSection }) {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="40" height="40">
                            <rect x="15" y="15" width="170" height="170" rx="32" ry="32"
                                  fill="#1a1a2e" stroke="#e94560" stroke-width="4"/>

                            <text x="82" y="132" font-family="Arial, Helvetica, sans-serif"
                                  font-size="108" font-weight="bold" text-anchor="middle"
                                  fill="#ffffff">
                                К
                            </text>

                            <text x="132" y="82" font-family="Arial, Helvetica, sans-serif"
                                  font-size="50" font-weight="bold" text-anchor="middle"
                                  fill="#f39c12">
                                2
                            </text>
                        </svg>
                        <p className="text-white-50">
                            Профессиональный монтаж натяжных потолков.
                            Качество, проверенное временем.
                        </p>
                    </div>
                    <div className="col-lg-4 mb-4">
                        <h5>Номера для связи 📞</h5>
                        <div className="d-flex align-items-center flex-column">
                            <a href="tel:+79068500007" className="text-light text-decoration-none mb-2">
                                +7 (906) 850-00-07
                            </a>
                            <a href="tel:+79090948654" className="text-light text-decoration-none">
                                +7 (909) 094-86-54
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-4 mb-4">
                        <h5>Мы в соцсетях</h5>
                        <div className="social-links">
                            <a className="text-decoration-none" href="https://vk.ru/id134654937">VK</a>
                            <a className="text-decoration-none" href="https://t.me/k2_potolki">TG</a>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p className="mb-0">© {currentYear} K2. Все права защищены.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;